<template>
<div>
    <div class="benefits">
      <p class="benefits__title"><strong>{{formattedTitle}}</strong></p>
      <ul class="benefits__list">
        <li class="benefits__item" v-for="item in items" :key="item.id">
          <img src="//styles.uk-tla.com/img/check-dq.svg" />
          <span class="benefits__item benefits__text">{{ item.text }}</span>
        </li>
      </ul>
    </div>
    <div class="benefits__market-trends">
      <p class="benefits__market-trends-text"><strong>{{formattedMarketTrendsTitle}}</strong></p>
      <span>{{formattedMarketTrendsText}}</span>
    </div>
  </div>
</template>

<script lang="ts">
import {
  Component, Prop, Vue, Watch
} from 'vue-property-decorator';
import ListItem from '../../viewmodels/ListItem';
import { tokenService } from '../../services/TokenService';

@Component
export default class BlurredPricingCurveBenefitsComponent extends Vue {
  @Prop({
    default: () => [
      'Based on data from the last 3 months',
      'Provide an indication of the price you\'re likely to pay']
  })
  public benefits!: string[];

  @Prop({ default: 'Benefits of Pricing Data' })
  public title!: string;

  @Prop({ default: 'Don\'t miss out!' })
  public marketTrendsTitle!: string;

  @Prop({ default: 'We analyse the UK vehicleType market and give you intel on current market pricing trends' })
  public marketTrendsText!: string;

  public get formattedTitle() {
    return tokenService.replaceToken(this.title);
  }

  public get formattedMarketTrendsTitle() {
    return tokenService.replaceToken(this.marketTrendsTitle);
  }

  public get formattedMarketTrendsText() {
    return tokenService.replaceToken(this.marketTrendsText);
  }

  private items: ListItem[] = [];

  public mounted() {
    this.items = this.benefits.map((a: any, i: number) => new ListItem(i, tokenService.replaceToken(a)));
  }
}
</script>
